import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import './submitLoading';
// Every layout loads this bundle, including the CDN-cached learn and blog
// layouts, which is the whole point — see ./ahoy.
import './ahoy';
// Imported after ./ahoy so the beacon is configured before the observer can
// fire; it no-ops on every page with no [data-section] elements.
import './sectionReach';
// No-ops on every page without #checkoutRoot.
import './checkout';

document.addEventListener('DOMContentLoaded', () => {
  const userRoot = document.getElementById('userRoot');
  if (userRoot) {
    const userRootContainer = ReactDOM.createRoot(userRoot);
    userRootContainer.render(<App />);
  }
});
